import styles from './MainAction.module.css'
import {LGBTButton} from "../../../../components/lgbtButton/LGBTButton";
import {MainPage} from "../../MainPage";
import {useNavigate} from "react-router-dom";
export const MainActions = () =>{
const navigation = useNavigate()
    return (
        <div className={styles.main_actions_content}>
            <LGBTButton
                onClick={()=>{navigation("/addresult")}}
                text={"Добавить тренировку"} textSize='16px'/>
            <LGBTButton
                onClick={()=>{window.location.href='https://messenger.online.sberbank.ru/sl/z5r7R1rMldSEzwSLI'}}
                children={<div className={styles.main_actions_button_money_transfer}>
                    {"Сделать \n благотворительный перевод"}
                </div>}
                isBorder={true}
            />

        </div>
    )
};